import type {GradientTextureNode} from "#material/cycles/types"
import type {TextureGradientType} from "#material/nodes/texture/tex-gradient/types"

export const cyclesGradientType = (type?: TextureGradientType): GradientTextureNode["parameters"]["gradient_type"] => {
    if (!type) {
        return undefined
    }
    switch (type) {
        case "LINEAR":
            return "linear"
        case "QUADRATIC":
            return "quadratic"
        case "EASING":
            return "easing"
        case "DIAGONAL":
            return "diagonal"
        case "SPHERICAL":
            return "spherical"
        case "QUADRATIC_SPHERE":
            return "quadratic_sphere"
        case "RADIAL":
            return "radial"
        default:
            throw new Error(`Unknown gradient type in tex gradient node: ${type}`)
    }
}
